import CRUDActions from '../CRUD';
import {CustomStreamEvent} from '../../api/stream/CustomStreamEvent';
import {StreamProvider, streamProviderFactory} from "../../api/stream/index";
import {ActiveRecord} from "../../api/ActiveRecord";

export class StreamActions extends CRUDActions {
  prefix = 'stream_event';

  getModel(streamProvider: StreamProvider) {
    return streamProviderFactory(streamProvider);
  }

  get _model() {
    return CustomStreamEvent;
  }

  fetchList(query = {}) {
    this._page = 1;

    return async(dispatch, getState) => {
      let state = getState();
      let provider = state.auth.user.club.stream_provider;
      dispatch({type: this.fetchListAction, query});

      try {
        let items = <ActiveRecord[]> await this.getModel(provider)
          .listAction(query, this.pageSize, this._page - 1);

        dispatch({
          type: this.fetchListFinishedSuccessAction,
          hasMore: items.length == this.pageSize,
          items
        });

        return items;
      }

      catch (error) {
        console.error(error);
        dispatch({
          type: this.fetchListFinishedFailAction,
          error
        });

        throw error;
      }
    };
  }

  fetchListMore(query = {}) {
    this._page++;
    return async(dispatch, getState) => {
      let state = getState();
      let provider = state.auth.user.club.stream_provider;

      dispatch({type: this.fetchListMoreAction});
      try {
        let items = await this.getModel(provider).listAction(query, this.pageSize, this._page - 1);

        return dispatch({
          type: this.fetchListMoreFinishedSuccessAction,
          hasMore: items.length == this.pageSize,
          items
        });

      }
      catch (error) {
        return dispatch({
          type: this.fetchListMoreFinishedFailAction,
          error
        });
      }
    }
  }

  createModel() {
    return async(dispatch, getState) => {
      let state = getState();
      let provider = state.auth.user.club.stream_provider;
      return dispatch({
        type: this.createModelAction,
        model: new (this.getModel(provider))()
      });
    }
  }

  /**
   *
   * @param {} model
   * @returns {function(*)}
   */
  publish(model: CustomStreamEvent, data: any) {
    return async(dispatch) => {
      dispatch({
        type: this.saveItemAction,
        id: model.id
      });
      try {
        let updatedModel = await model.publish(data);

        dispatch({
          type: this.saveItemFinishedSuccessAction,
          model: updatedModel
        });

        return true;
      }
      catch (error) {
        dispatch({
          type: this.saveItemFinishedFailAction,
          error
        });
        return false;
      }
    }
  }
}

export const streamAction = new StreamActions();



// WEBPACK FOOTER //
// ./src/actions/stream/customStream.ts